import React from 'react'
import StudentOnlineClass from '../../components/StudentTabs/StudentOnlineClass/StudentOnlineClass'

const OnlineClass = () => {
  return (
    <div>
        <StudentOnlineClass />
    </div>
  )
}

export default OnlineClass